var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 9.16667C12.9167 7.55583 11.6108 6.25 10 6.25C8.38917 6.25 7.08334 7.55583 7.08334 9.16667C7.08334 10.7775 8.38917 12.0833 10 12.0833C11.6108 12.0833 12.9167 10.7775 12.9167 9.16667Z",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9022 9.45825C13.1706 9.53958 13.4552 9.58333 13.75 9.58333C15.3608 9.58333 16.6667 8.2775 16.6667 6.66667C16.6667 5.05583 15.3608 3.75 13.75 3.75C12.2376 3.75 10.994 4.90117 10.8477 6.37511",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15225 6.37511C9.006 4.90117 7.76244 3.75 6.25 3.75C4.63917 3.75 3.33334 5.05583 3.33334 6.66667C3.33334 8.2775 4.63917 9.58333 6.25 9.58333C6.54484 9.58333 6.82946 9.53958 7.09773 9.45825",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.7499C18.3333 11.4488 16.2813 9.58325 13.75 9.58325",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 16.2499C14.5833 13.9488 12.5313 12.0833 10 12.0833C7.46869 12.0833 5.41666 13.9488 5.41666 16.2499",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.58325C3.71869 9.58325 1.66666 11.4488 1.66666 13.7499",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanels);
export default __webpack_public_path__ + "static/media/panels.5753e2ce32821127a37646a4dc7b279c.svg";
export { ForwardRef as ReactComponent };